module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "microphoneSettingHelp flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "help flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": _vm.clickButton
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "microphoneSettingHelpInner"
  }, [_c('h3', {
    staticClass: "helpHeadline font22"
  }, [_vm._v("マイク設定について")]), _vm._v(" "), _c('dl', {
    staticClass: "helpDetail"
  }, [_c('dt', [_vm._v("マイクを正しく設定できない場合は、次のことを試してみてください。")]), _vm._v(" "), _c('dd', [_c('ul', [_c('li', [_vm._v("ヘッドセットが接続されていることと、マイクが消音になっていないことを確認します。")]), _vm._v(" "), (_vm.platform.name == 'Chrome') ? _c('li', [_vm._v("使用しているヘッドセットが[マイクの選択]で選択されていることを確認します。")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("音声が検出されやすいように、マイクを口に近付けます。")]), _vm._v(" "), _c('li', [_vm._v("周囲に雑音がないことを確認します。")]), _vm._v(" "), _c('li', [_vm._v("通常の速度ではっきりと話します。")])])]), _vm._v(" "), _c('dt', [_vm._v("次の手順で、システム設定を調整します。")]), _vm._v(" "), _c('dd', [_c('ul', [_c('li', [_vm._v("マイクの入力レベルが低すぎないことを確認します。")]), _vm._v(" "), _c('li', [_vm._v("マイクが現在の入力デバイスとして選択されていることを確認します。")]), _vm._v(" "), (_vm.isFlash) ? _c('li', [_vm._v("以下の手順に従って、本サイトのマイク使用が許可されていることを確認します。")]) : (_vm.platform.name == 'Chrome' || _vm.platform.name == 'Firefox' || _vm.platform.name == 'Safari') ? _c('li', [_vm._v("ブラウザの設定で、本サイトのマイク使用が許可されていることを確認します。")]) : (_vm.platform.name == 'Microsoft Edge') ? _c('li', [_vm._v("Windowsのマイク設定で、[Microsoft Edge]がマイクを使用できるアプリとして設定されていることを確認します。")]) : _vm._e(), _vm._v(" "), (_vm.isFlash) ? _c('span', [_c('a', {
    staticClass: "help-anchor",
    attrs: {
      "href": "http://www.sourcenext.com/support/qa/?faq=RS-08885",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sourcenext.com/support/qa/?faq=RS-08885")])]) : _vm._e()])]), _vm._v(" "), (_vm.platform.name == 'Microsoft Edge') ? _c('dt', [_vm._v("ブラウザがマイク使用許可を確認してきた場合は、次の手順で操作します。")]) : _vm._e(), _vm._v(" "), (_vm.platform.name == 'Microsoft Edge') ? _c('dd', [_c('ul', [_c('li', [_vm._v("[一度のみ許可]または[常に許可]のどちらかを選択します。")]), _vm._v(" "), _c('span', [_vm._v("※[常に許可]を選択することをお勧めします。")]), _vm._v(" "), _c('li', [_vm._v("[一度のみ許可]または[常に許可]のどちらも選択しなかった場合は、本サイトの再表示が必要になります。")])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "return",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickButton
    }
  }, [_c('span', {
    staticClass: "close_text"
  }, [_vm._v("戻る")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a144160", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-7a144160","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MicrophoneSettingHelp.vue
// module id = 878
// module chunks = 1